// extracted by mini-css-extract-plugin
export var locationCard = "_gu-0";